import React from 'react'

interface PaginationProps {
  currentPage: number
  totalPages: number
  onPageChange: (page: number) => void
}

const Pagination: React.FC<PaginationProps> = ({ currentPage, totalPages, onPageChange }) => {
  return (
    <div className='pagination-container mt-30 text-center'>
      <ul className='pagination justify-content-center'>
        <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
          <a
            className='page-link'
            href='#'
            onClick={(e) => {
              e.preventDefault()
              if (currentPage > 1) onPageChange(currentPage - 1)
            }}
            tabIndex={currentPage === 1 ? -1 : undefined}
          >
            <i className='fas fa-angle-left' />
          </a>
        </li>

        {Array.from({ length: totalPages }, (_, i) => i + 1).map(page => (
          <li key={page} className={`page-item ${page === currentPage ? 'active' : ''}`}>
            <a
              className='page-link'
              href='#'
              onClick={(e) => {
                e.preventDefault()
                onPageChange(page)
              }}
            >
              {page}
            </a>
          </li>
        ))}

        <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
          <a
            className='page-link'
            href='#'
            onClick={(e) => {
              e.preventDefault()
              if (currentPage < totalPages) onPageChange(currentPage + 1)
            }}
            tabIndex={currentPage === totalPages ? -1 : undefined}
          >
            <i className='fas fa-angle-right' />
          </a>
        </li>
      </ul>
    </div>
  )
}

export default Pagination
